import { helpers } from "veritone-redux-common";
import _ from "lodash";
import { FETCH_FOLDERS } from "./folder";
import { fromJS } from "immutable";
import { defaultChartSelector } from './../../../helpers/defaultInfo';
import { getRangeBeforeCampaign } from 'components/DatePicker/constants';
import { AD_PERFORMANCE_CHART_ID, GEO_CHART_ID } from '../../../helpers/constant';
import { ActionType, Status } from './campaign/actions';
import { REMOVE_ADVERTISER } from "./advertiser";
import { attachGeoChildrenData } from 'components/DashboardTab/preprocessData';

const { createReducer } = helpers;

export const namespace = "campaign";

export const ADD_CAMPAIGN = "add campaign";
export const DUPLICATE_CAMPAIGN = "duplicate campaign";
export const DUPLICATE_CAMPAIGN_SAGA = "duplicate campaign saga";
export const REMOVE_CAMPAIGN = "remove campaign";
export const UPDATE_CAMPAIGN = "update campaign";
export const UPDATE_CAMPAIGN_DETAIL = "update campaign detail";
export const REMOVE_CAMPAIGN_SAGA = "remove campaign saga";
export const ADD_CAMPAIGN_SAGA = "add campaign saga";
export const UPDATE_CAMPAIGN_SAGA = "update campaign saga";
export const UPDATE_CHART_DATA_CAMPAIGN = "update chart data for campaign";
export const UPDATE_CHART_DATA_CAMPAIGN_SAGA =
  "update chart data for campaign saga";
export const GET_CAMPAIGN_SAGA = "get campaign saga";
export const UPDATE_SELECTED_CHART_CAMPAIGN = "update selected in chart";
export const LOAD_CAMPAIGN = "load campaign";
export const NEXT_STEP = "next step";
export const NEXT_STEP_CAMPAIGN_SAGA = "next campaign step saga";
export const BACK_STEP = "back step";
export const SET_STEP = `${namespace}/go to step`;
export const TOGGLE_DOWNLOAD = "toggle download";
export const GET_CALENDAR_DATA_SAGA = "get calendar data saga";
export const GET_CALENDAR_DATA = "get calendar data";
export const UPDATE_INFOMATION_FORM_REPORT = "update information form";
export const GET_DETAIL_STATION_SAGA = "get detail station saga";
export const REMOVE_CREATIVE_SAGA = "remove creative saga";
//date range
export const CHANGE_DATE_RANGE = "change date range";
export const GET_DATE_RANGE = "get date range";
export const TOGGLE_COMPARE = "toogle compare";
export const UNDO_CREATIVE_NAME = "undo creative name"
export const UNDO_CREATIVE_NAME_SAGA = "undo creative name saga"
export const UPDATE_SUMMARY_DRILL_DOWN_SAGA = "update summary drill down saga"

export const GET_DATA_DRILL_DOWN_SAGA = "get data drill down saga";
export const UPDATE_DATA_DRILL_DOWN = "update data drill down"
export const REMOVE_CHART_DATA = "remove chart data"
export const UNDO_UPDATE_DATA_DRILLDOWN_SAGA = "undo update drill down saga"
export const SHOW_TOAST_SUMMARY_DRILLDOWN = "show toast summaty drill down"
export const LOAD_SUMMARY_DRILLDOWN = "load summary drill down"
export const MOVE_BACK_REASSIGN_SAGA = "move back reassign saga"
export const UPDATE_DATA_DISPLAY_FOR_GEO_TAB = "update data display for geo tab"
export const OVERRIDE_CHART_DATA_CAMPAIGN = "override chart data campaign"
export const CAPTURE_GEO_CHART = "campaign/CAPTURE_GEO_CHART"
export const SET_DEFAULT_CHARTS_SELECTOR = "campaign/SET_DEFAULT_CHARTS_SELECTOR";
export const SET_ALL_DEFAULT_CHARTS_SELECTOR = "campaign/SET_ALL_DEFAULT_CHARTS_SELECTOR";
export const SET_CHARTS_SELECTOR = "campaign/SET_CHARTS_SELECTOR";
export const SET_TABLE_SORT_STATUS = "campaign/SET_TABLE_SORT_STATUS";
export const LOAD_ADPERFORMANCE_CHART_DATA = "campaign/LOAD_ADPERFORMANCE_CHART_DATA";
export const LOAD_ADPERFORMANCE_CHART_DATA_SAGA = "campaign/LOAD_ADPERFORMANCE_CHART_DATA_SAGA";
export const UPDATE_ADPERFORMANCE_CHART_DATA = "campaign/UPDATE_ADPERFORMANCE_CHART_DATA";
export const CHANGE_LOADING_STATUS_CHART = "campaign/CHANGE_LOADING_STATUS_CHART";
export const UPDATE_LASTTIME_CAMPAIGN_COLLECTED = "campaign/UPDATE_LASTTIME_CAMPAIGN_COLLECTED";
export const LOAD_CAMPAIGN_PROGRESS_BAR_STATUS_SAGA = "campaign/LOAD_CAMPAIGN_PROGRESS_BAR_STATUS_SAGA";
export const REMOVE_CAMPAIGN_DATA = "campaign/REMOVE_CAMPAIGN_DATA";

function getSecondDate(selected) {
  const { start, end } = selected;
  const seconds = end.getTime() - start.getTime();
  const endSecond = new Date(start.getTime() - 24 * 60 * 60 * 1000);
  const startSecond = new Date(start.getTime() - seconds - 24 * 60 * 60 * 1000);
  return {
      start: startSecond,
      end: endSecond
  };
}

export const LOAD_CAMPAIGN_DETAIL_SAGA = "load campaign detait on dashboard";
export const UPDATE_CAMPAIGN_DETAIL_LOADING_STATUS = "campaign/updateCampaignDetailLoadingStatus";

const defaultState = {
  byId: {},
  allIds: []
};

const initialChartLoading = {
  [AD_PERFORMANCE_CHART_ID]: "initial"
}

export const campaignReducer = createReducer(defaultState, {
  [ADD_CAMPAIGN]: (state, action) => {
    const { campaign } = action.payload;
    return {
      byId: {
        ...state.byId,
        [campaign.campaign_id]: {
          ...campaign
        }
      },
      allIds: [...state.allIds, campaign.campaign_id]
    };
  },
  [DUPLICATE_CAMPAIGN]: (state, action) => {
    const { campaign } = action.payload;
    return {
      byId: {
        ...state.byId,
        [campaign.campaign_id]: {
          ...campaign
        }
      },
      allIds: [...state.allIds, campaign.campaign_id]
    };
  },
  [REMOVE_CAMPAIGN]: (state, action) => {
    const { campaign } = action.payload;
    const newCampaignState = { ...state.byId };
    delete newCampaignState[campaign.campaign_id];
    return {
      byId: {
        ...newCampaignState
      },
      allIds: state.allIds.filter(id => id !== campaign.campaign_id)
    };
  },
  [UPDATE_CAMPAIGN]: (state, action) => {
    const { campaign } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaign.campaign_id]: {
          ...state.byId[campaign.campaign_id],
          ...campaign
        }
      }
    };
  },
  [SET_STEP]: (state, action) => {
    const { step } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        editing: {
          ...state.byId["editing"],
          activeStep: step
        }
      }
    };
  },

  [LOAD_CAMPAIGN]: (state, action) => {
    return {
      ...state,
      byId: {
        ...state.byId,
        [action.meta.campaign_id]: {
          ...state.byId[action.meta.campaign_id],
          ...action.payload
        }
      }
    };
  },

  [UPDATE_CAMPAIGN_DETAIL_LOADING_STATUS]: (state, action) => {
    const { campaignId, loadingState } = action.payload;
    const campaign = state.byId[campaignId] || {};
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...campaign,
          detailLoadingStatus: loadingState
        }
      }
    };
  },
  
  [CHANGE_LOADING_STATUS_CHART]: (state, action) => {
    const { campaignId, chartId, status } = action.payload;
    const currentChartLoading = _.get(state, ['byId', campaignId, 'chartLoading']);
    const chartLoadingObj = currentChartLoading ? currentChartLoading : initialChartLoading;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          chartLoading: {
            ...chartLoadingObj,
            [chartId]: status
          }
        }
      }
    }
  },

  [CHANGE_DATE_RANGE]: (state, action) => {
    const { campaignId, selected , typeDatePicker, value, isChange} = action.payload;
    if (typeDatePicker === "masterCalendar" || typeDatePicker === "firstCalendar" || typeDatePicker === "reportCalendar") {
      return {
        ...state,
        byId: {
            ...state.byId,
            [campaignId]: {
                ...state.byId[campaignId],
                masterCalendar: { selected, value },
                firstCalendar: { selected, value: -1 },
                secondCalendar: { selected: getRangeBeforeCampaign(selected), value: -1 },
            }
        }
      };
    }

    if (typeDatePicker === "campaignCalendar") {
      if (!campaignId) {return state;}
      return {
        ...state,
        byId: {
          ...state.byId,
          [campaignId]: {
            ...state.byId[campaignId],
            start_date: _.get(selected, "start", undefined),
            end_date: _.get(selected, "end", undefined),
            campaignCalendar: { selected, value: isChange ? -1 : 0 }
          }
        }
      };
    }
    
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          [typeDatePicker]: { selected, value }
        }
      }
    };
  },

  [TOGGLE_COMPARE]: (state, action) => {
      const { campaignId, isCompare } = action.payload;
      return {
          ...state,
          byId: {
              ...state.byId,
              [campaignId]: {
                  ...state.byId[campaignId],
                  isCompare
              }
          }
      };
  },
  
  [UPDATE_CHART_DATA_CAMPAIGN]: (state, action) => {
    const { campaign } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaign.campaign_id]: {
          ...state.byId[campaign.campaign_id],
          ...campaign
        }
      }
    };
  },

  [OVERRIDE_CHART_DATA_CAMPAIGN]: (state, action) => {
    const { chartData, campaignId } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          chartData
        }
      }
    };
  },

  [UPDATE_ADPERFORMANCE_CHART_DATA] : (state, action) => {
    const { campaignId, masterRange, adPerformanceInfo } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          chartData: {
            ...state.byId[campaignId].chartData,
            [masterRange]: {
              ...state.byId[campaignId].chartData[masterRange],
              3: {
                ...state.byId[campaignId].chartData[masterRange]["3"],
                ...adPerformanceInfo
              }
            }
          }
        }
      }
    }
  },
 
  [UNDO_CREATIVE_NAME]: (state, action) => {
    const { campaignId, isUndoCreativeName } = action.payload
    return {
        ...state,
        byId: {
          ...state.byId,
          [campaignId]: {
            ...state.byId[campaignId],
            isUndoCreativeName
          }
        }
    }
  },

  [UPDATE_SELECTED_CHART_CAMPAIGN]: (state, action) => {
    const { campaignId, chartKey, chartId, selected } = action.payload;
    const immutableState = fromJS(state);
    return immutableState
      .setIn(
        ["byId", campaignId, "chartData", chartKey, chartId, "selected"],
        selected
      )
      .toJS();
  },

  [UPDATE_DATA_DRILL_DOWN]: (state, action) => {
    const {
      dataMentions,
      frozenDataMentions,
      excludeMentionList,
      frozenExcludeList,
      reassignMentionsList,
      frozenReassignList,
      campaignId
     } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          dataDrillDown: {
            ...state.byId[campaignId].dataDrillDown,
            dataMentions,
            frozenDataMentions,
            excludeMentionList,
            frozenExcludeList,
            reassignMentionsList,
            frozenReassignList,
          }
        }
      }
    }
  },

  [LOAD_SUMMARY_DRILLDOWN]: (state, action) => {
    const { campaignId, summaryLoadingState } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          dataDrillDown: {
            ...state.byId[campaignId].dataDrillDown,
            loading: summaryLoadingState.loading,
            loaded: summaryLoadingState.loaded
          }
        }
      }
    }
  },

  [REMOVE_ADVERTISER]: (state, action) => {
    const { advertiser } = action.payload;
    const { advertiser_id, campaigns = [] } = advertiser;
    if ( advertiser_id === 'editing') {
      return state;
    }
    const newById = {...state.byId};
    const newAllIds = [...state.allIds];
    for (let campaign of campaigns) {
      const campaignId = campaign.campaign_id;
      delete newById[campaignId];
      const findIndex = newAllIds.findIndex(id => id === campaignId);
      newAllIds.splice(findIndex, 1);
    }
    
    return { ...state, byId: newById, allIds: newAllIds };
  },
  
  [REMOVE_CHART_DATA]: (state, action) => {
    const { campaignId } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          chartData: {}
        }
      }
    }
  },
  
  [REMOVE_CAMPAIGN_DATA]: (state, action) => {
    const { campaignId } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: _.pick(state.byId[campaignId], ['campaign_id', 'campaign_name', 'last_modified']),
      }
    }
  },

  [SHOW_TOAST_SUMMARY_DRILLDOWN]: (state, action) => {
    const { campaignId, status } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          isShowToast: status
        }
      }
    }
  },
  [UPDATE_DATA_DISPLAY_FOR_GEO_TAB]: (state, action) => {
    const { campaignId, dataDisplay , chartKey, chartId } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          chartData: {
            ...state.byId[campaignId].chartData,
            [chartKey]: {
              ...state.byId[campaignId].chartData[chartKey],
              [chartId]: {
                ...state.byId[campaignId].chartData[chartKey][chartId],
                data: {
                  ...state.byId[campaignId].chartData[chartKey][chartId].data,
                  dataDisplay
                }
              }
            }
          }
        }
      }
    }    
  },
  [CAPTURE_GEO_CHART]: (state, action) => {
    const { campaignId, src, chartId, chartKey } = action.payload;
    const chartData = _.get(state, ['byId', campaignId, 'chartData', chartKey]);
    //TODO: move checking logic to VeritoneGeoChart
    return chartData ? {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          chartData: {
            ...state.byId[campaignId].chartData,
            [chartKey]: {
              ...state.byId[campaignId].chartData[chartKey],
              [chartId]: {
                ...state.byId[campaignId].chartData[chartKey][chartId],
                imageForGeoChart: {
                  src
                }
              }
            }
          }
        }
      }
    } : state;
  },
  [SET_DEFAULT_CHARTS_SELECTOR]: (state, action) => {
    const { campaignId } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          chartSelector: defaultChartSelector
        }
      }
    }
  },

  [SET_ALL_DEFAULT_CHARTS_SELECTOR]: (state, action) => {
    const { campaignId, chartSelector } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          chartSelector
        }
      }
    }
  },

  [SET_CHARTS_SELECTOR]: (state, action) => {
    const { campaignId, chartId, updateSelector } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          chartSelector: {
            ...state.byId[campaignId].chartSelector,
            [chartId]: {
              ...state.byId[campaignId].chartSelector[chartId],
              ...updateSelector
            }
          }
        }
      }
    }
  },
  [SET_TABLE_SORT_STATUS]: (state, action) => {
    const { campaignId, chartId, updateSortStatus } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          tableSortStatus: {
            ...state.byId[campaignId].tableSortStatus,
            [chartId]: {
              ...updateSortStatus
            }
          }
        }
      }
    }
  },
  [LOAD_ADPERFORMANCE_CHART_DATA]: (state, action) => {
    const { campaign } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaign.campaign_id]: {
          campaign
        }
      }
    }
  },
  [UPDATE_LASTTIME_CAMPAIGN_COLLECTED]: (state, action) => {
    // {
    //   444: value,
    //   1278: value
    // }
    const listCampaigns = { ...state.byId };
    const allIds = [...state.allIds];
    const newById = allIds.reduce((acc, item) => {
      acc[item] = {
        ...listCampaigns[item],
        lastUpdated: action['payload']['dataTimeStamp'][item]
      };
      return acc;
    }, {});
    return {
      ...state,
      byId: {
        ...newById
      }
    }
  },
  [ActionType.SET_CAMPAIGNS]: (state, action) => {
    const { campaigns, requestCampaignIds = [] } = action.payload;
    const newById = { ...state.byId };
    const newAllIds = [ ...state.allIds ];
    const failCampaignIds = [...requestCampaignIds];

    //for loaded and authorized campaign
    campaigns && campaigns.forEach(campaign => {
      const { id, campaign_id, campaign_name, name, startDate, endDate, advertiserId } = campaign;
      const currentId = id || campaign_id;
      const currentName = name || campaign_name;
      const prevData = _.get(newById, currentId, {});
      newById[currentId] = {
        ...prevData,
        ...campaign,
        //Convert to snake case for backward compatibility
        //TODO: remove this
        campaign_id: currentId,
        campaign_name: currentName,
        start_date: startDate,
        end_date: endDate,
        advertiser_id: advertiserId,
        loadStatus: startDate && endDate ? Status.LOADED : campaign.loadStatus
      }
      !_.includes(newAllIds, currentId) && newAllIds.push(currentId);

      const tempIndexInFailList = failCampaignIds.indexOf(currentId);
      tempIndexInFailList !== -1 && failCampaignIds.splice(tempIndexInFailList, 1);
    })
    //for campaign that is requested but fail to load
    //TODO: use other over byId and loadStatus
    failCampaignIds.forEach(id => {
      const campaignInfo = newById[id] || {};
      newById[id] = {
        ...campaignInfo,
        loadStatus: Status.ERROR
      }
      !_.includes(newAllIds, id) && newAllIds.push(id);
    })
    const newState = {
      ...state,
      byId: newById,
      allIds: newAllIds
    };
    return newState;
  },
  [ActionType.SET_CAMPAIGN_PERMISSIONS]: (state, action) => {
    const { campaignId, permissions } = action.payload;
    const newState = {...state};
    const campaignData = _.get(newState, ['byId', campaignId]);
    if (campaignData) {
      newState.byId[campaignId] = {...campaignData, ...permissions};
    }
    return newState;
  },

  [ActionType.SET_SELECTED_ADSOURCES]: (state, action) => {
    const { selected, campaignId } = action.payload;
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          selectedAdSources: selected
        }
      }
    }
  },
  [ActionType.SET_CAMPAIGN_CHARTDATA]: (state, action) =>
    {
      const { chartData = {}, campaignId, dateRange } = action.payload;
      const currentCampaign = state.byId[campaignId];
      if (!(campaignId && currentCampaign && dateRange)) {
        return state;
      }
      const currentChartData = _.get(state, ['byId', campaignId, 'chartData', dateRange], {});
      return {
        ...state,
        byId: {
          ...state.byId,
          [campaignId]: {
            ...state.byId[campaignId],
            chartData: {
              ...state.byId[campaignId].chartData,
              [dateRange]: {
                ...currentChartData,
                ...chartData
              }
            }
          }
        }
      };
    },
  [ActionType.SET_GEOLOCATION_CHILDREN] : (state, action) =>
  {
    const { geoData, campaignId, dateRange, locationIds = [] } = action.payload;
    const chartData = _.get(state, ['byId', campaignId, 'chartData', dateRange, GEO_CHART_ID]);
    if (!chartData || _.isEmpty(chartData)) {
      return { ...state };
    }
    const newChartData = attachGeoChildrenData(chartData, geoData, locationIds);
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          chartData: {
            ...state.byId[campaignId].chartData,
            [dateRange]: {
              ...state.byId[campaignId].chartData[dateRange],
              [GEO_CHART_ID]: newChartData
            }
          }
        }
      }
    };
  },
  [ActionType.SET_GEO_LOADING_STATUS]: (state, action) => {
    const { status, campaignId, dateRange } = action.payload;
    
    const geoData = _.get(state, ['byId', campaignId, 'chartData', dateRange, GEO_CHART_ID]);
    if (!geoData) {
      return state;
    }
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          chartData: {
            ...state.byId[campaignId].chartData,
            [dateRange]: {
              ...state.byId[campaignId].chartData[dateRange],
              [GEO_CHART_ID]: {
                ...state.byId[campaignId].chartData[dateRange][GEO_CHART_ID],
                status
              }
            }
          }
        }
      }
    };
  },
  [ActionType.SET_TARGET_LOCATION_PATH]: (state, action) => {
    const { targetLocationPath , campaignId, dateRange } = action.payload;
    const geoData = _.get(state, ['byId', campaignId, 'chartData', dateRange, GEO_CHART_ID]);
    if (!geoData) {
      return state;
    }
    return {
      ...state,
      byId: {
        ...state.byId,
        [campaignId]: {
          ...state.byId[campaignId],
          chartData: {
            ...state.byId[campaignId].chartData,
            [dateRange]: {
              ...state.byId[campaignId].chartData[dateRange],
              [GEO_CHART_ID]: {
                ...state.byId[campaignId].chartData[dateRange][GEO_CHART_ID],
                targetLocationPath
              }
            }
          }
        }
      }
    };
  },
  [ActionType.SET_CAMPAIGN_PROGRESS_BAR_STATUS]: (state, action) =>
    {
      const { campaignId, percentComplete } = action.payload;
      const currentCampaign = state.byId[campaignId];
      if (!(campaignId && currentCampaign && percentComplete)) {
        return state;
      }
      return {
        ...state,
        byId: {
          ...state.byId,
          [campaignId]: {
            ...state.byId[campaignId],
            percentComplete
          }
        }
      };
    },
    [ActionType.SET_CAMPAIGN_NEW_HASH_WINDOW]: (state, action) =>
      {
        const { campaignId, hashWindow } = action.payload;
        const currentCampaign = state.byId[campaignId];
        if (!(campaignId && currentCampaign && hashWindow)) {
          return state;
        }
        return {
          ...state,
          byId: {
            ...state.byId,
            [campaignId]: {
              ...state.byId[campaignId],
              percentComplete: 0,
              hashWindow
            }
          }
        };
      }
});

export const loadAdperformanceChartData = (campaign) => ({
  type: LOAD_ADPERFORMANCE_CHART_DATA,
  payload: {
    campaign
  }
})

export const loadAdperformanceChartDataSaga = (campaignId, advertiserId, adPerformanceRange) => ({
  type: LOAD_ADPERFORMANCE_CHART_DATA_SAGA,
  payload: {
    campaignId,
    advertiserId,
    adPerformanceRange
  }
})

export const updateAdperformanceChartData = (campaignId, masterRange, adPerformanceInfo) => ({
  type: UPDATE_ADPERFORMANCE_CHART_DATA,
  payload: {
    campaignId,
    masterRange,
    adPerformanceInfo
  }
})

export const setChartSelector = (campaignId, chartId, updateSelector) => (
  {
    type: SET_CHARTS_SELECTOR,
    payload: {
      campaignId,
      chartId,
      updateSelector
    }
  }
)

export const setTableSortStatus = (campaignId, chartId, updateSortStatus) => (
  {
    type: SET_TABLE_SORT_STATUS,
    payload: {
      campaignId,
      chartId,
      updateSortStatus
    }
  }
)

export const setDefaultChartSelector = (campaignId) => ({
  type: SET_DEFAULT_CHARTS_SELECTOR,
  payload: {
    campaignId
  }
})

export const setAllDefaultChartSelector = (campaignId, chartSelector) => ({
  type: SET_ALL_DEFAULT_CHARTS_SELECTOR,
  payload: {
    campaignId,
    chartSelector
  }
}) 

export const captureGeoChart = (campaignId, src, chartId, chartKey) => ({
  type: CAPTURE_GEO_CHART,
  payload: {
    campaignId,
    src,
    chartId, 
    chartKey
  }
})

export const updateDataDisplayForGeoTab = (campaignId, dataDisplay, chartKey, chartId, src) => ({
  type: UPDATE_DATA_DISPLAY_FOR_GEO_TAB,
  payload: {
    campaignId,
    dataDisplay,
    chartKey,
    chartId,
    src
  }
})

export const updateCampaign = campaign => ({
  type: UPDATE_CAMPAIGN,
  payload: {
    campaign
  }
});

export const updateCampaignSaga = (campaign, oldCampaign) => ({
  type: UPDATE_CAMPAIGN_SAGA,
  payload: {
    campaign,
    oldCampaign
  }
});

export const addCampaign = campaign => ({
  type: ADD_CAMPAIGN,
  payload: {
    campaign
  }
});

export const duplicateCampaign = campaign => ({
  type: DUPLICATE_CAMPAIGN,
  payload: {
    campaign
  }
});

export const duplicateCampaignSaga = campaign => ({
  type: DUPLICATE_CAMPAIGN_SAGA,
  payload: {
    campaign
  }
});

export const addCampaignSaga = campaign => ({
  type: ADD_CAMPAIGN_SAGA,
  payload: {
    campaign
  }
});

export const removeCampaign = campaign => ({
  type: REMOVE_CAMPAIGN,
  payload: {
    campaign
  }
});


export const removeCampaignSaga = campaign => ({
  type: REMOVE_CAMPAIGN_SAGA,
  payload: {
    campaign
  }
});

export const updateSelectedChartCampaign = ({
  campaignId,
  chartKey,
  chartId,
  selected
}) => {
  return {
    type: UPDATE_SELECTED_CHART_CAMPAIGN,
    payload: {
      campaignId,
      chartKey,
      chartId,
      selected
    }
  };
};

export const updateChartDataCampaign = campaign => ({
    type: UPDATE_CHART_DATA_CAMPAIGN,
    payload: {
      campaign
    }
  });

export const overrideChartDataCampaign = (chartData, campaignId) => ({
    type: OVERRIDE_CHART_DATA_CAMPAIGN,
    payload: {
      chartData,
      campaignId
    }
  });

export const loadChartDataCampaignSaga = (advertiser, campaign, dateRange, isOverride = false) => ({
    type: UPDATE_CHART_DATA_CAMPAIGN_SAGA,
    payload: {
      advertiser,
      campaign,
      dateRange,
      isOverride
    }
  });

export const loadCampaignProgressBarSaga = (campaign, advertiser, sessionToken) => ({
  type: LOAD_CAMPAIGN_PROGRESS_BAR_STATUS_SAGA,
  payload: {
    campaign,
    advertiser,
    sessionToken
  }
});

export const loadCampaignDetail = campaign => ({
  type: UPDATE_CAMPAIGN_DETAIL,
  payload: {
    campaign
  }
});

export const toggleCompare = (campaignId, isCompare) => ({
  type: TOGGLE_COMPARE,
  payload: {
    campaignId,
    isCompare
  }
});

export const getCampaignSaga = (campaignId, currentTab) => ({
  type: GET_CAMPAIGN_SAGA,
  payload: { 
      campaignId,
      currentTab
   }
});

export const getDetailStationSaga = campaign => ({
  type: GET_DETAIL_STATION_SAGA,
  payload: { campaign }
});

export const setStep = step => ({
  type: SET_STEP,
  payload: {
    step
  }
});

export const nextStepCampaignSaga = campaign => ({
  type: NEXT_STEP_CAMPAIGN_SAGA,
  payload: {
    campaign
  }
});

export const loadCampaign = (campaignId, loadingState) => ({
  type: LOAD_CAMPAIGN,
  meta: { campaign_id: campaignId },
  payload: {
    ...loadingState
  }
});

export const updateCampaignDetailLoadingStatus = (campaignId, loadingState) => {
  return {
  type: UPDATE_CAMPAIGN_DETAIL_LOADING_STATUS,
  payload: {
    campaignId,
    loadingState
  }
}};


export const changeLoadingStatus = (campaignId, chartId, status) => ({
  type: CHANGE_LOADING_STATUS_CHART,
  payload: {
    campaignId, chartId, status
  }
});

export const changeDateRange = (campaignId, selected, typeDatePicker, value, isChange) => ({
  type: CHANGE_DATE_RANGE,
  payload: {
      campaignId,
      selected,
      typeDatePicker,
      value,
      isChange
  }
});

export const removeCreativeSaga = (advertiser, campaign, creative) => ({
  type: REMOVE_CREATIVE_SAGA,
  payload: {
    advertiser,
    campaign,
    creative
  }
})

export const undoCreativeSaga = (advertiser, campaign, creative) => ({
  type: UNDO_CREATIVE_NAME_SAGA,
  payload: {
    advertiser,
    campaign,
    creative
  }
})

export const undoCreativeName = (campaignId, isUndoCreativeName) => ({
  type: UNDO_CREATIVE_NAME,
  payload: {
    campaignId,
    isUndoCreativeName
  }
})

export const removeCampaignData = (campaignId) => ({
  type: REMOVE_CAMPAIGN_DATA,
  payload: {
    campaignId,
  }
})


export const updateSummaryDrillDownSaga = ({
    excludeMentionList,
    reassignMentionsList,
    campaign,
    advertiser,
    summaryJobTitle,
    messageSnackbar,
    mentionsToReassign,
    paramGetData
}) => {
  return ({
    type: UPDATE_SUMMARY_DRILL_DOWN_SAGA,
    payload: {
      excludeMentionList,
      reassignMentionsList,
      campaign,
      advertiser,
      summaryJobTitle,
      messageSnackbar,
      mentionsToReassign,
      paramGetData
    },
  }
)}

export const moveBackReassignSaga = (
    campaign,
    advertiser,
    reassignMentionsList,
    excludeMentionList,
    paramGetData,
    summaryJobTitle
  ) => 
  ({
    type: MOVE_BACK_REASSIGN_SAGA,
    payload: {
      campaign,
      advertiser,
      reassignMentionsList,
      excludeMentionList,
      paramGetData,
      summaryJobTitle
    }
})

export const getDataDrillDownSaga = (campaignId, isUrlChange, drilldownInfo) => {
    return ({
      type: GET_DATA_DRILL_DOWN_SAGA,
      payload: {
        campaignId,
        isUrlChange,
        drilldownInfo
      },
    })
}

export const updateDataDrillDown = (
    dataMentions,
    frozenDataMentions,
    excludeMentionList,
    frozenExcludeList,
    reassignMentionsList,
    frozenReassignList,
    campaignId
) => {
  return ({
  type: UPDATE_DATA_DRILL_DOWN,
  payload: {
    dataMentions,
    frozenDataMentions,
    excludeMentionList,
    frozenExcludeList,
    reassignMentionsList,
    frozenReassignList,
    campaignId
  }, 
})}

export const undoUpdateDrillDownSaga = (
  frozenDataMentions,
  frozenExcludeList,
  frozenReassignList,
  campaign,
  advertiser,
  summaryJobTitle
) => ({
  type: UNDO_UPDATE_DATA_DRILLDOWN_SAGA,
  payload: {
    frozenDataMentions,
    frozenExcludeList,
    frozenReassignList,
    campaign,
    advertiser,
    summaryJobTitle
  }
})

export const loadSummaryDrilldown = (
  campaignId,
  summaryLoadingState
) => {
  return ({
  type: LOAD_SUMMARY_DRILLDOWN,
  payload: {
    campaignId,
    summaryLoadingState
  }
})}

export const removeChartData = (campaignId) => ({
  type: REMOVE_CHART_DATA,
  payload: {
    campaignId
  }
})

export const showToastSummaryDrilldown = (campaignId, status) => {
  return ({
  type: SHOW_TOAST_SUMMARY_DRILLDOWN,
  payload: {
    campaignId,
    status
  }
})}

export const updateLastTimeCampaignCollected = (dataTimeStamp) => ({
  type: UPDATE_LASTTIME_CAMPAIGN_COLLECTED,
  payload: {
    dataTimeStamp
  }
})

export const getCampaignByAdvertiserId = state => advertiserId => {
  const campaignList = _.get(state, ["advertiser", "byId", advertiserId, "campaigns"], []);
  return campaignList.map(campaign => {
    const campaignId = campaign && campaign.campaign_id;
    return _.get(state, ["campaign", "byId", campaignId])
  }
  );
};

export const getCampaign = state => campaignId => state.campaign.byId[campaignId] || {};
export const getCampaignInAdvertiser = state => campaigns => {
  let listCampaigns = []
  const totalCampaigns = _.get(state, "campaign.byId", {})
  campaigns.map(campaign => {
    listCampaigns.push(totalCampaigns[campaign])
  })
  return listCampaigns
}

export const getCampaigns = state => state.campaign;

export const getNewCampaign = state =>
  state.campaign.byId.new || { campaign_id: "new" };

export const loadCampaignDetailSaga = campaignId => ({
  type: LOAD_CAMPAIGN_DETAIL_SAGA,
  payload: {
    campaignId
  }
});

export const getMasterCalendar = state => campaignId => _.get(state, [namespace, 'byId', campaignId, 'masterCalendar']);

//For backward compatibility, try to use loadCampaigns action in app/campaign/actions.js if possible
export const loadCampaigns = (campaignIds, mustLoad) => ({
  payload: { campaignIds, mustLoad },
  type: ActionType.LOAD_CAMPAIGNS
});

export default campaignReducer;
